import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { NavbarPortal } from 'app/components';
import logo from 'app/images/Xplir_logo_RepPil_vektor_rgb.svg';

import { useUser } from 'app/state/contexts/UserContext';
import MainMenu from './MainMenu';
import OrganizationMenu from './OrganizationMenu';
import { createPortal } from 'react-dom';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import { NotificationsDrawer } from '../editor/navbar/NotificationsDrawer';
import { useComments } from 'entities/comment';
import { useRouteParams } from 'app/router/params';

const NavbarDefault = () => {
  const { user } = useUser();
  const { documentId } = useRouteParams();
  const { commentNotifications } = useComments('');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const openNotificationCount = commentNotifications?.filter((notification) => notification.closedAt === null).length ?? 0;
  const projectMentionCount = documentId
    ? commentNotifications?.filter(
        (notification) => notification.closedAt === null && notification.publishedAt !== null && String(notification.meta.documentSuperId) === documentId
      ).length ?? 0
    : 0;
  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <NavbarPortal>
      <div className="d-flex justify-content-between">
        <div className="navbar--logo">
          <Link to="/">
            <img alt="logo" src={logo} />
          </Link>
        </div>
        <div className="d-flex">
          <OrganizationMenu />
          <MainMenu />
          <div className="navbar-bell d-flex align-items-center px-3 position-relative" onClick={() => setIsDrawerOpen(true)}>
            <i className="fa-regular fa-bell"></i>
            {projectMentionCount > 0 ? (
              <p className="navbar-notification-count-icon">{projectMentionCount}</p>
            ) : (
              openNotificationCount > 0 && <span className="notification-badge" />
            )}
          </div>
        </div>
      </div>
      {createPortal(
        <Drawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} direction="right" size={450}>
          <NotificationsDrawer onClose={() => setIsDrawerOpen(false)} />
        </Drawer>,
        document.body,
        'notifications-drawer'
      )}
    </NavbarPortal>
  );
};

export default NavbarDefault;
